import React, { createContext, useState, useMemo } from "react"
import useDataApi from "../hooks/useDataApi"
import { fnGetNormsRequisits } from "../services/norms"
import * as yup from "yup"
import intl from "react-intl-universal"
import { fnListBlocks } from "../services/blocks"
import { fn } from "moment"

export const StatesOfModals = createContext(null)

export const StatesOfModalsProvider = ({ children }) => {
  const schema = yup.object().shape({
    name: yup.string().required(intl.get("form.required_field")),
    description: yup.string().required(intl.get("form.required_field")),
    responsibles: yup
      .array()
      .min(1, intl.get("form.required_field"))
      .of(yup.number())
      .required(intl.get("form.required_field")),
    requisites: yup.array(),
  })

  const [bIsOpenModalEditBoard, fnSetBIsOpenModalEditBoard] = useState(false)
  const [bIsOpenModalAddBoard, fnSetBIsOpenModalAddBoard] = useState(false)
  const [bIsOpenModalInteractionsBoard, fnSetBIsOpenModalInteractionsBoard] =
    useState(false)
  const [bIsOpenModalMoveBoard, fnSetIsOpenModalMoveBoard] = useState(false)
  const [bIsOpenModalMoveAlertBoard, fnSetIsOpenModalMoveAlertBoard] = useState(false)
  const [bIsOpenModalDeleteBoardWarning, fnSetBIsOpenModalDeleteBoardWarning] =
    useState(false)
  const [bIsOpenModalDeleteBoardAlert, fnSetBIsOpenModalDeleteBoardAlert] =
    useState(false)
  const [bIsOpenModalDeleteBoard, fnSetBIsOpenModalDeleteBoard] = useState(false)
  const [bIsOpenModalCalcMemory, fnSetBIsOpenModalCalcMemory] = useState(false)
  const [aNorms, fnSetANorms] = useState([])
  const [bIsOpenModalCreateNoModelBoard, fnSetBIsOpenModalCreateNoModelBoard] =
    useState(false)

  const [bIsOpenModalShowDetails, fnSetBIsOpenModalShowDetails] = useState(false)
  const [oNormsRequisitsRes, fnGetNormsRequisitsReq] = useDataApi(fnGetNormsRequisits)
  const [oBlocksRes, fnGetBlocksReq] = useDataApi(fnListBlocks)

  const fnOpenModalShowDetails = () => {
    fnSetBIsOpenModalShowDetails(true)
    fnSetBIsOpenModalAddBoard(false)
  }
  const fnCloseModalShowDetails = () => {
    fnSetBIsOpenModalShowDetails(false)
    fnSetBIsOpenModalAddBoard(true)
  }
  const fnCompleteModalShowDetails = () => {
    fnSetBIsOpenModalShowDetails(false)
    fnSetBIsOpenModalAddBoard(false)
  }

  const fnOpenModalEditBoard = () => {
    fnSetBIsOpenModalEditBoard(true)
    fnSetBIsOpenModalCreateNoModelBoard(true)
    fnSetBIsOpenModalAddBoard(false)
  }
  const fnOpenCreateFromZeroModal = () => {
    fnSetBIsOpenModalCreateNoModelBoard(true)
    fnSetBIsOpenModalAddBoard(false)
  }
  const fnCloseCreateFromZeroModal = () => {
    fnSetBIsOpenModalCreateNoModelBoard(false)
    fnSetBIsOpenModalAddBoard(false)
  }
  const fnCloseModalEditBoard = () => {
    fnSetBIsOpenModalEditBoard(false)
    fnSetBIsOpenModalAddBoard(false)
  }
  const fnCloseModalAddBoard = () => {
    fnSetBIsOpenModalEditBoard(false)
    fnSetBIsOpenModalAddBoard(false)
  }
  const fnOpenModalAddBoard = () => {
    fnSetBIsOpenModalAddBoard(true)
    fnSetBIsOpenModalEditBoard(false)
  }
  const fnOpenModalCalcMemory = () => {
    fnSetBIsOpenModalCalcMemory(true)
  }
  const fnCloseModalCalcMemory = () => {
    fnSetBIsOpenModalCalcMemory(false)
  }

  const fnOpenModalAlertDeleteBoard = async (oBoard) => {
    fnSetBIsOpenModalDeleteBoardWarning(true)
    const response = await fnGetBlocksReq(oBoard?.id)
    const bHasBlocks = response?.data?.data?.length
    if (!bHasBlocks) {
      fnSetBIsOpenModalDeleteBoardWarning(false)
      fnSetBIsOpenModalDeleteBoardAlert(true)
    }
  }

  const fnCloseModalDeleteBoard = () => {
    fnSetBIsOpenModalDeleteBoardAlert(false)
    fnSetBIsOpenModalDeleteBoard(false)
  }
  const fnOpenModalDeleteBoard = () => {
    fnSetBIsOpenModalDeleteBoardAlert(false)
    fnSetBIsOpenModalDeleteBoard(true)
  }

  function fnHandleModalMoveAlert() {
    fnSetIsOpenModalMoveBoard(false)
    fnSetIsOpenModalMoveAlertBoard(true)
  }

  const closeModalMoveAlert = () => {
    fnSetIsOpenModalMoveAlertBoard(false)
  }
  async function fnGetNormsSubmit() {
    const response = await fnGetNormsRequisitsReq()
    const aRequisits = response?.data.map((r) => ({
      value: r.req_nid,
      label: r.req_cname,
    }))

    fnSetANorms(aRequisits)
  }

  const value = useMemo(() => {
    return {
      fnGetNormsSubmit,
      fnCloseModalAddBoard,
      fnSetBIsOpenModalAddBoard,
      fnOpenModalAddBoard,
      fnOpenModalEditBoard,
      fnCloseModalEditBoard,
      fnSetBIsOpenModalDeleteBoardWarning,
      fnOpenModalAlertDeleteBoard,
      fnOpenModalDeleteBoard,
      fnCloseModalDeleteBoard,
      fnSetBIsOpenModalInteractionsBoard,
      fnSetIsOpenModalMoveBoard,
      fnHandleModalMoveAlert,
      fnSetIsOpenModalMoveAlertBoard,
      closeModalMoveAlert,
      fnOpenModalCalcMemory,
      fnCloseModalCalcMemory,
      bIsOpenModalCalcMemory,
      bIsOpenModalEditBoard,
      bIsOpenModalInteractionsBoard,
      bIsOpenModalMoveBoard,
      bIsOpenModalDeleteBoardWarning,
      bIsOpenModalDeleteBoardAlert,
      bIsOpenModalDeleteBoard,
      bIsOpenModalAddBoard,
      bIsOpenModalMoveAlertBoard,
      fnOpenCreateFromZeroModal,
      fnCloseCreateFromZeroModal,
      bIsOpenModalCreateNoModelBoard,
      bIsOpenModalShowDetails,
      fnOpenModalShowDetails,
      fnCloseModalShowDetails,
      fnCompleteModalShowDetails,
      aNorms,
      schema,
      oBlocksRes,
      oNormsRequisitsRes,
    }
  }, [
    bIsOpenModalEditBoard,
    bIsOpenModalInteractionsBoard,
    bIsOpenModalMoveBoard,
    bIsOpenModalDeleteBoardWarning,
    bIsOpenModalDeleteBoardAlert,
    bIsOpenModalDeleteBoard,
    bIsOpenModalMoveAlertBoard,
    bIsOpenModalAddBoard,
    aNorms,
    schema,
    oBlocksRes,
  ])

  return <StatesOfModals.Provider value={value}>{children}</StatesOfModals.Provider>
}

export default StatesOfModals
